// extracted by mini-css-extract-plugin
export default {"codeInput":"LoginForm_codeInput__wISvu","code":"LoginForm_code__WrAMx"};